import { render, staticRenderFns } from "./MopFkComponent.vue?vue&type=template&id=0d34854c&scoped=true&"
import script from "./MopFkComponent.vue?vue&type=script&lang=js&"
export * from "./MopFkComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d34854c",
  null
  
)

export default component.exports